import { pontosHexagono } from '@/design/favo';
import { cn } from '@/lib/utils';

/* Hexágono — o marcador do sistema.
 *
 * Onde outro produto põe um ponto ou um quadradinho de legenda, este põe uma
 * célula. Não é enfeite: é o mesmo objeto do favo de cem células e do medidor
 * de veredito, em escala de texto, e é o que faz a legenda e o gráfico
 * parecerem a mesma coisa em vez de duas que o leitor precisa casar sozinho.
 *
 * `cor` recebe SEMPRE um `var(--token)`. Nenhum hex entra aqui. */

export type HexinhoProps = {
  /** Uma referência de token: `var(--cascata-1)`, `var(--positivo)`… */
  cor?: string | undefined;
  tamanho?: number | undefined;
  className?: string | undefined;
};

export function Hexinho({ cor = 'currentColor', tamanho = 13, className }: HexinhoProps) {
  const r = tamanho / 2;
  const altura = tamanho * 1.15;
  return (
    <svg
      width={tamanho}
      height={altura}
      viewBox={`0 0 ${tamanho} ${altura}`}
      className={cn('shrink-0', className)}
      aria-hidden="true"
      focusable="false"
    >
      <polygon points={pontosHexagono(r, altura / 2, r)} fill={cor} />
    </svg>
  );
}

/* Célula vazia: o contorno sem nada dentro.
 *
 * Significa "ninguém encheu isto" e é o par visual do Hexinho: onde um diz
 * quanto foi coberto, o outro diz quanto ficou descoberto. Tracejado, porque
 * contorno cheio pareceria só um hexágono de outra cor. */
export function HexVazio({ cor = 'var(--negativo)', tamanho = 13, className }: HexinhoProps) {
  const r = tamanho / 2;
  const altura = tamanho * 1.15;
  return (
    <svg
      width={tamanho}
      height={altura}
      viewBox={`0 0 ${tamanho} ${altura}`}
      className={cn('shrink-0', className)}
      aria-hidden="true"
      focusable="false"
    >
      <polygon
        points={pontosHexagono(r, altura / 2, r - 0.8)}
        fill="none"
        stroke={cor}
        strokeOpacity=".55"
        strokeWidth="1.4"
        strokeDasharray="2.6 2.2"
      />
    </svg>
  );
}

/** O símbolo da FAVO: duas células alongadas. */
export function MarcaFavo({ tamanho = 30, className }: { tamanho?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 509 534"
      width={tamanho}
      height={tamanho}
      className={cn('shrink-0', className)}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="var(--marca-teal)"
        d="M223,16L318,252c4,9,4,20,0,29L223,518c-4,10-13,16-24,16h-77c-11,0-20-6-24-16L3,282c-4-9-4-20,0-29L98,16C102,6,112,0,122,0h77C210,0,219,6,223,16z"
      />
      <path
        fill="var(--marca-verde)"
        d="M386,0h-99l104,252c4,10,4,20,0,30L287,534h99c11,0,20-6,24-16l97-241c3-6,3-13,0-19L410,16C406,6,397,0,386,0z"
      />
    </svg>
  );
}
